import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";

export interface ZoneFAQProps {
  cityName: string;
  items: { question: string; answer: string }[];
}

export default function ZoneFAQ({ cityName, items }: ZoneFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4 text-center">
            Preguntas frecuentes en {cityName}
          </h2>
          <div className="w-10 h-1 bg-primary mx-auto rounded-full mb-10"></div>

          <div className="flex flex-col gap-3">
            {items.map((item, i) => (
              <div
                key={i}
                className="bg-surface-alt rounded-xl border border-border/50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className="font-body font-semibold text-sm md:text-base text-text-primary">
                    {item.question}
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${
                      openIndex === i
                        ? "bg-primary text-white"
                        : "bg-white text-text-secondary border border-border"
                    }`}
                  >
                    {openIndex === i ? "−" : "+"}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <p className="font-body text-sm md:text-base text-text-secondary leading-relaxed px-5 pb-5 md:px-6 md:pb-6 pt-0 -mt-1">
                        {item.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}